import { makeStyles } from '@material-ui/core';
import React, { useEffect, useMemo, useState } from 'react';

const useStyles = makeStyles(theme => ({
}));
const PostPaymentScreen = ({}) => {
  const classes = useStyles()
  return (
    <>src/pages/CustomerBookingCreate/9/PostPayment/index.jsx</>
  )
}

export {PostPaymentScreen}